import { useEffect, useState } from "react";

import { API_BASE_URL } from "../../../config";
import { getAdminAuthToken } from "../../../auth/auth";
import Loader from "../../../components/Loader";

export default function Dashboard() {
  const [dashInfo, setDashInfo] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const token = getAdminAuthToken();
  useEffect(() => {
    const handleDashInfo = async () => {
      setIsLoading(true);
      const response = await fetch(`${API_BASE_URL}/admin/dashboard`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (result.status === false) {
        return { error: result.message || "Failed to fetch info" };
      }

      setDashInfo(result.data);
      setIsLoading(false);
    };

    handleDashInfo();
  }, []);
  return (
    <>
      <div className="dashboard-page-wrapper">
        <h2>Dashboard</h2>
        <div className="dashboard-list-wrapper">
          <div className="dashboard-list-wrapper__users dashboard-list-wrapper__all">
            <h3>Total Users</h3>
            {isLoading ? <Loader /> : <span>{dashInfo?.total_users}</span>}
          </div>
          <div className="dashboard-list-wrapper__companies dashboard-list-wrapper__all">
            <h3>Total Companies</h3>
            {isLoading ? <Loader /> : <span>{dashInfo?.total_companies}</span>}
          </div>
          <div className="dashboard-list-wrapper__jobs dashboard-list-wrapper__all">
            <h3>Total Jobs</h3>
            {isLoading ? <Loader /> : <span>{dashInfo?.total_jobs}</span>}
          </div>
          <div className="dashboard-list-wrapper__proffesionals dashboard-list-wrapper__all">
            <h3>Total Candidates</h3>
            {isLoading ? (
              <Loader />
            ) : (
              <span>{dashInfo?.total_professionals}</span>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
